<template>
  <button
    :disabled="disabled || loading"
    :class="[
      $style.button,
      disabled ? $styleColor.disabled : $styleColor[type]
    ]"
  >
    <g-spinner v-if="loading" />
    <template v-else>
      <span v-if="label">
        {{ label }}
      </span>
    </template>
  </button>
</template>

<script>
import GSpinner from './GSpinner.vue';

export default {
  components: {
    GSpinner,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'link',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    // const classColor = computed(() => context.$style[props.type]);
    // const classColor = context.$style.link;

    // return {
    //   classColor,
    // };
  },
};
</script>

<style lang="scss" module>
.button {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  height: 48px;
  @apply flex items-center py-3 px-6 rounded-lg justify-center;
}
</style>

<style lang="scss" module="$styleColor">
.link {
  @apply text-basic-0 bg-link-500 hover:bg-link-400 active:bg-link-700;
}
.disabled {
  @apply text-basic-700 bg-basic-400
}
</style>
